export default __webpack_public_path__ + "static/mask-image-58e087ec35099cb749c70e22d97fe934.png";